import * as ActionTypes from '../actions/types';
import xs from 'xstream';
import * as actions from '../actions';
import GENERAL_FUNCTIONS from '../utils/functions/functions';
import delay from 'xstream/extra/delay';
import sampleCombine from 'xstream/extra/sampleCombine';
import HEADER_FUNCTIONS from '../utils/functions/headers';

const REQUEST_CLAIM_DOCUMENT = 'requestClaimDocument';
const REQUEST_DOCUMENT_WITH_QUERY_PARAMS = 'requestDocumentWithQueryParams';

export function requestDocumentWithQueryParams(sources) {
    const state$ = sources.STATE;
    const token$ = state$.map(state => state.applicationUser.accessToken);

    const request$ = sources.ACTION.filter(action => {
        return (
            action.type === ActionTypes.FETCH_DOCUMENT_TYPES_WITH_QUERY_PARAMS
        );
    })
        .compose(delay())
        .compose(sampleCombine(token$))
        .map(([action, token]) => ({
            url: `${GENERAL_FUNCTIONS.getBaseURL()}api/Attachment/ClaimApplication/${action.payload.claimApplicationId}/claimant/search${GENERAL_FUNCTIONS.createUrlQueryParameters(action.payload.filters)}`,
            headers: HEADER_FUNCTIONS.headersWithTokenJson(token),
            category: REQUEST_DOCUMENT_WITH_QUERY_PARAMS,
            method: 'GET',
        }));

    let httpResponse$ = sources.HTTP.select(REQUEST_DOCUMENT_WITH_QUERY_PARAMS)
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.fetchClaimDocumentWithQueryParamsSuccess(response)
                : actions.fetchClaimDocumentWithQueryParamsFailed(response),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}

export function requestClaimDocument(sources) {
    const state$ = sources.STATE;
    const token$ = state$.map(state => state.applicationUser.accessToken);

    const request$ = sources.ACTION.filter(
        action => action.type === ActionTypes.FETCH_CLAIM_DOCUMENT,
    )
        .compose(delay())
        .compose(sampleCombine(token$))
        .map(([action, token]) => ({
            url: `${GENERAL_FUNCTIONS.getBaseURL()}api/Attachment/ClaimApplication/${action.payload.claimApplicationId}/claimant`,
            headers: HEADER_FUNCTIONS.headersWithTokenJson(token),
            category: REQUEST_CLAIM_DOCUMENT,
            method: 'GET',
        }));
    let httpResponse$ = sources.HTTP.select(REQUEST_CLAIM_DOCUMENT)
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.fetchClaimDocumentSuccess(response)
                : actions.fetchClaimDocumentFailed(response),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}
